







































import Vue from 'vue'
import SignInUpCommon from '@/components/user/SignInUpCommon.vue'
import ResetPasswordDialog from '@/components/user/ResetPasswordDialog.vue'
import EmailValidation from '@/service/EmailValidation'

export default Vue.extend({
  name: 'ResetPassword',
  components: {
    SignInUpCommon,
    ResetPasswordDialog,
  },
  data: () => ({
    email: '',
    emailRules: [
      (v: string) => !!v || 'Email is required.',
      (v: string) =>
        EmailValidation.isValid(v) || 'Enter correct e-mail address.',
    ],
    showDialog: false
  }),
  methods: {
    sendResetLink() {
      this.$api
        .post('/reset_password/request', { email: this.email })
        .finally(() => {
          this.showDialog = true
        })
    },
    closeDialog() {
      this.showDialog = false
      this.$router.push('/sign-in')
    }
  }
})
